/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { Global, jsx } from '@emotion/react';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { tableStyles } from './common-styles';
export var GlobalStylesWrapper = function GlobalStylesWrapper(_ref) {
  var featureFlags = _ref.featureFlags,
    isDragAndDropEnabledOption = _ref.isDragAndDropEnabledOption,
    api = _ref.api;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['editorViewMode'], function (states) {
      var _states$editorViewMod;
      return {
        mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
      };
    }),
    mode = _useSharedPluginState.mode;
  var isLivePageViewMode = mode === 'view';
  return jsx(Global, {
    styles: tableStyles({
      featureFlags: featureFlags,
      isDragAndDropEnabled: isDragAndDropEnabledOption && !isLivePageViewMode
    })
  });
};